export const meta: BlockMeta = {
  title: "Journal Header",
  tags: ["#page"],
  postMetaBlock: {
    fieldName: "journalHeader",
    postTypes: ["journal"],
  },
}

import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import dayjs from "dayjs"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"
import { cn } from "tailwind-variants"

export default defineBlock("content/journal-header", (props) => {
  return (
    <div className="block-spacing !mt-0 flex flex-col gap-7">
      <Appear className="relative">
        <div
          className={cn(
            "content-sized pb-8 flex flex-col items-start justify-end text-white",
            env.admin && "h-[60vh]",
            !env.admin && "h-[88vh] md:h-[100vh]",
          )}
        >
          <div className="absolute top-0 left-0 w-full h-full">
            {props.featuredImage?.mediaItemUrl && (
              <ResponsiveImage {...props.featuredImage} className="w-full h-full" objectFit="cover" />
            )}
          </div>
          <div className="absolute left-0 top-0 w-full h-[35vw] md:h-[20vw] bg-gradient-to-b from-[rgba(0,0,0,0.75)]" />
          <div className="absolute left-0 bottom-0 w-full h-[35vw] md:h-[20vw] bg-gradient-to-t from-[rgba(0,0,0,0.75)]" />
          <div className="flex flex-col w-full relative">
            <h2 className="type-mobile-headings-heading-l md:type-desktop-headings-heading-l md:w-1/2">
              {env.admin ? (
                <EditableText as="span" store={usePostTitleEditor()} className="" placeholder="Enter a title" />
              ) : (
                props.journal?.title
              )}
            </h2>
          </div>
        </div>
      </Appear>
      <div className="content-sized flex items-center justify-between gap-3">
        <div className="flex gap-3">
          <Link className={cn("plain-button")} href="/journals">
            Back
          </Link>
          {props.category?.name && <div className={cn("plain-button active")}>{props.category?.name}</div>}
        </div>
        <div className="flex gap-3 type-desktop-label-label-m font-medium">
          {dayjs(props.journal?.date).format("D MMMM YYYY")}
        </div>
      </div>
    </div>
  )
})
